import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import "@/index.css";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Templates from "@/pages/Templates";
import Discover from "@/pages/Discover";
import Pricing from "@/pages/Pricing";
import CreateWizard from "@/pages/CreateWizard";
import Editor from "@/pages/Editor";
import PublicTimeline from "@/pages/PublicTimeline";
import Present from "@/pages/Present";
import Embed from "@/pages/Embed";
import Import from "@/pages/Import";
import Analytics from "@/pages/Analytics";
import Profile from "@/pages/Profile";
import Collections from "@/pages/Collections";
import CollectionPublic from "@/pages/CollectionPublic";
import Compare from "@/pages/Compare";
import Workspace from "@/pages/Workspace";
import Admin from "@/pages/Admin";
import { SlashMark } from "@/components/Logo";

const Loader = () => (
  <div className="min-h-screen grid place-items-center bg-background">
    <div className="animate-pulse"><SlashMark size={40} color="hsl(var(--primary))" /></div>
  </div>
);

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/discover" element={<Discover />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/templates" element={<Templates />} />
            <Route path="/t/:username/:slug" element={<PublicTimeline />} />
            <Route path="/u/:username" element={<Profile />} />
            <Route path="/c/:username/:slug" element={<CollectionPublic />} />
            <Route path="/present/:username/:slug" element={<Present />} />
            <Route path="/embed/:username/:slug" element={<Embed />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/collections" element={<Protected><Collections /></Protected>} />
            <Route path="/workspace" element={<Protected><Workspace /></Protected>} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="/create" element={<Protected><CreateWizard /></Protected>} />
            <Route path="/import" element={<Protected><Import /></Protected>} />
            <Route path="/editor/:id" element={<Protected><Editor /></Protected>} />
            <Route path="/analytics" element={<Protected><Analytics /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
